<template>
    <div class="ZElHeader flex items-center" style="padding:0 15px;border-bottom: 1px solid rgba(56, 56, 56, 1);">
        <div style="width: 350px;">
            <SidebarLogo/>
        </div>
        <Navbar :isNav="isNav"/>
    </div>
</template>
<script setup lang="ts">
import { watch, ref } from 'vue'
import SidebarLogo from '@/layout/components/Sidebar/Logo.vue'
import Navbar from '@/layout/components/Navbar.vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const isNav = ref(false)
watch(() => route.path, (path) => {
  if (['manageCenter/worldMap'].includes(path)) {
    isNav.value = true;
  } else {
    isNav.value = true;  // 原本false
  }
}, {
  immediate: true
})



</script>
<style lang="scss" scoped>
    .ZElHeader {
        height: 50px;
        background: rgba(3, 11, 31, 1);
        // background: #222;
    }
</style>

<style lang="scss">
    .ZElHeader {
        height: 50px;
        background: rgba(3, 11, 31, 1);
        // background: #222;

        .navbar .topmenu-container {
            background: transparent;
        }
        .topmenu-container.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus, .topmenu-container.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, .topmenu-container.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
            background: transparent !important;
        }
    }
</style>




